angular.module('account.tags', [
  'account.tags.index',
  'account.tags.add',
  'account.tags.detail'
]);



// WEBPACK FOOTER //
// ./client/src/app/account/tags/index.js